import { UPDATE_USER, UPDATE_HIGHFIVES, LOAD_TODAYHAPPINESS, SET_SHORTCUTS, SET_ACTIVE_SHORTCUT, SET_MYHAPPINESS, SET_EMPLOYEE_HAPPINESS, SET_CUSTOMER, VALIDATING_CUSTOMER } from '../types.js';

const initialState = {
  user: {
    uid: '',
    loggedIn: false,
    profilePic: ''
  },
  company: {
    customerId: null,
    employeeHappiness: null,
    companyCubics: null,
    info: {}
  },
  activeShortcut: {
    link: null,
    faviconLink: null,
    title: null
  },
  shortcuts: [],
}

export default function reducerState (state = initialState, action) {
  switch(action.type) {
    case UPDATE_USER :
      return { ...state, user: action.payload}
    case LOAD_TODAYHAPPINESS :
      return { ...state, todayHappiness: action.payload }
    case SET_MYHAPPINESS :
      return { ...state, todayHappiness: {...state.todayHappiness, [action.label]: action.payload } }
    case SET_CUSTOMER :
      return { ...state, company: {...state.company, ...action.payload, validatingCustomer: false} };
    case SET_EMPLOYEE_HAPPINESS :
      return { ...state, company: {...state.company, employeeHappiness: action.payload} };
    case VALIDATING_CUSTOMER:
      return {...state, company: {...state.company, validatingCustomer: false}};
    case SET_SHORTCUTS :
      return { ...state, shortcuts: action.payload };
    case SET_ACTIVE_SHORTCUT :
      return { ...state, activeShortcut: action.payload };
    default:
      return state;
  }
}
